export default __webpack_public_path__ + "static/media/misc-closet2-1920w.112200b6.webp";